import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';

import { DocumentItem } from '../../interfaces/document-item.interface';
import { OrderItemsDialogData } from '../../interfaces/dialog-data.interface';
import { ItemsTableComponent } from '../../components/items-table/items-table.component';
import { DgNumberPipe } from '../../dg-number.pipe';
import { DocumentGenerateConfigService } from '../../document-generate-config.service';

@Component({
  selector: 'app-order-items-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ItemsTableComponent,
    DgNumberPipe,
    TranslatePipe,
  ],
  templateUrl: './order-items-modal.component.html',
})
export class OrderItemsModalComponent implements OnInit, OnDestroy {
  // en pantallas de poca altura (móvil horizontal) el encabezado no deja ver los artículos
  shortScreen = false;
  private shortScreenSub?: Subscription;

  constructor(
    private dialogRef: MatDialogRef<OrderItemsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderItemsDialogData,
    public dgConfig: DocumentGenerateConfigService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    this.shortScreenSub = this.breakpointObserver
      .observe('(max-height: 560px)')
      .subscribe((state) => (this.shortScreen = state.matches));
  }

  ngOnDestroy(): void {
    this.shortScreenSub?.unsubscribe();
  }

  rowSubtotal(item: DocumentItem): number {
    return item.quantity * item.price - (this.data.taxIncluded ? item.isv : 0);
  }

  rowTotal(item: DocumentItem): number {
    return this.rowSubtotal(item) - item.discount + item.isv;
  }

  get totalSubtotal(): number {
    return this.data.items.reduce((sum, i) => sum + this.rowSubtotal(i), 0);
  }

  get totalDiscount(): number {
    return this.data.items.reduce((sum, i) => sum + i.discount, 0);
  }

  get totalIsv(): number {
    return this.data.items.reduce((sum, i) => sum + i.isv, 0);
  }

  get montoTotal(): number {
    return this.data.items.reduce((sum, i) => sum + this.rowTotal(i), 0);
  }

  close(): void {
    this.dialogRef.close();
  }
}
